/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { ControlDefinition } from "@anvilor/ngx-rui";
import { LegacyRuiControl } from "@anvilor/ngx-rui";
import { RuiStore } from "@anvilor/ngx-rui";
import { RuiCompositeControl } from "@anvilor/ngx-rui";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

export const CONTROL_SUBMIT_BUTTON_PANEL = "anvilor_forms:submit_button_panel";

export interface SubmitButtonPanelControlDefinition extends ControlDefinition {
  control: typeof CONTROL_SUBMIT_BUTTON_PANEL;
  additional_disable?: boolean;
}

export class SubmitButtonPanelControl
  extends LegacyRuiControl<SubmitButtonPanelControlDefinition>
  implements RuiCompositeControl
{
  translatedControlDefinition$: Observable<ControlDefinition>;

  constructor(store: RuiStore, id: string) {
    super(store, id);

    this.translatedControlDefinition$ = this.selectors.rawDefn$.pipe(
      map((d) => {
        return {
          control: "panel",
          id: "_submit_panel",
          presentation: "elevated",
          styles: {
            padding: "20px",
          },
          body_controls: [
            {
              control: "flexbox",
              justify_content: "center",
              items: [
                {
                  control: {
                    control: "anvilor_forms:submit_button",
                    id: "submit_button",
                    additional_disable: d.additional_disable,
                  },
                },
              ],
            },
          ],
        };
      })
    );
  }
}
